import React from 'react';
import { Link } from 'react-router-dom';
import MainContainer from '../containers/main';

const PasswordResetComplete = () => {
    return (
        <MainContainer>
            <>
                <h1>Your password has been changed</h1>
                <Link to="/login/" className="btn mt-4 btn--primary-green mr-2 sm:mr-0">Login</Link>
                <a href="https://www.rnzcgp.org.nz" className="btn mt-4 btn--green-tint-1 ml-0 sm:ml-2">Visit rnzcgp.org.nz</a>
                <p className="mt-4 color-white-70">If you require help contact us at <a href="mailto:rnzcgp@rnzcgp.org.nz" className="no-underline"><strong>rnzcgp@rnzcgp.org.nz</strong></a></p>
            </>
        </MainContainer>

    );
};

export default PasswordResetComplete;
